import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';



export default function useAssetFilter(pageSettings , setPageSettings) {
    const [searchParams, setSearchParams] = useSearchParams();
    

    const [filterLoading, setFilterLoading] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },
    {
        key: "issued_date_after",
        label: "Issued After",
        value: searchParams.get("issued_date_after") || ""
    },
    {
        key: "issued_date_before",
        label: "Issued Before",
        value: searchParams.get("issued_date_before") || ""
    },
    {
        key: "returned_date_before",
        label: "Returned Before",
        value: searchParams.get("returned_date_before") || ""
    },
    {
        key: "returned_date_after",
        label: "Returned After",
        value: searchParams.get("returned_date_after") || ""
    },
   
  ]);

  useEffect(()=>{      
    
        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },
            {
                key: "issued_date_after",
                label: "Issued After",
                value: searchParams.get("issued_date_after") || ""
            },
            {
                key: "issued_date_before",
                label: "Issued Before",
                value: searchParams.get("issued_date_before") || ""
            },
            {
                key: "returned_date_after",
                label: "Returned After",
                value: searchParams.get("returned_date_after") || ""
            },
            {
                key: "returned_date_before",
                label: "Returned Before",
                value: searchParams.get("returned_date_before") || ""
            }
            
          ]
          setFilters(_filters)
 

 
  },[])

  const handleFilterChange =  (data, key, make_call=false) => {
    console.log( "AAAA")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = data?.label || ""
    selectedFilter['value'] = data?.value || ""
    setFilters(_filters)
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }


    
  };
  const handleInputChange = debounce((data, key, make_call=false) => {
    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
   
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){

        
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }

  }, 1000)

  const handleDateChange = (data, key, make_call=false) => {  
     let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){

        
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }

  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange
  };
}
